/* eslint eqeqeq: 0 */
import { combineReducers } from "redux";
import Immutable from "immutable";
import * as constants from "../constants/widgetList";
import { CLOSE_POPUP } from "../constants";
import {
  WidgetListItem,
  WidgetStatItem,
  Informer,
  TeaserInf
} from "../records/widget_list";
import TemplateGenerator from "../../staff/utils/templateGenerator";
import dateRange from "./dateRange";
import updateDate from "./updateDate";

const UPDATE_CONSTANTS = [
  constants.ON_SAVE_WIDGET_FORM_SUCCESS,
  constants.ON_DELETE_WIDGET_SUCCESS,
  constants.ON_COPY_WIDGET_SUCCESS
];

function widgetList(state = [], action) {
  if (action.type == constants.ON_LOAD_WIDGET_LIST) {
    return new Immutable.List(action.widgetList.objects).map(
      widget => new WidgetListItem(widget)
    );
  }
  return state;
}

const defaultWidgetPopupState = new Immutable.Map({
  isOpen: false,
  informer: new WidgetListItem(),
  errors: {},
  email: ""
});

function widgetPopup(state = defaultWidgetPopupState, action) {
  if (action.type == "@@redux/INIT") {
    return defaultWidgetPopupState.merge(state);
  }
  if (action.type == constants.OPEN_CODE_POPUP) {
    return state.merge({ isOpen: true, informer: action.informer });
  }
  if (action.type == constants.ON_SAVE_WIDGET_FORM_SUCCESS) {
    const infData = {
      name: action.informer.name,
      code: action.informer.code,
      id: action.informer.id
    };
    const informer = new WidgetListItem(infData);
    return state.merge({ isOpen: true, informer });
  }
  if (action.type == CLOSE_POPUP) {
    return defaultWidgetPopupState.merge({ email: state.get("email") });
  }
  if (action.type == constants.SET_EMAIL_FIELD) {
    return state.merge({ email: action.email });
  }
  if (action.type == constants.ON_SEND_EMAIL_FAILD) {
    return state.set("errors", action.errors);
  }
  if (action.type == constants.ON_SEND_EMAIL_SUCCESS) {
    return state.merge({ email: "", errors: {} });
  }
  return state;
}

const defaultWidgetCopyPopupState = new Immutable.Map({
  isOpen: false,
  informer: null,
  errors: {}
});

function widgetCopyPopup(state = defaultWidgetCopyPopupState, action) {
  if (action.type == constants.OPEN_WIDGET_COPY_POPUP) {
    return state.merge({ isOpen: true, informer: action.informer });
  }
  if (action.type == constants.ON_COPY_WIDGET_FAILED) {
    return state.set("errors", action.errors);
  }
  if (action.type == CLOSE_POPUP) {
    return defaultWidgetCopyPopupState;
  }
  return state;
}

const defaultWidgetStatPopupState = new Immutable.Map({
  isOpen: false,
  informer: new WidgetListItem(),
  daily: [],
  summary: {}
});

function widgetStatPopup(state = defaultWidgetStatPopupState, action) {
  if (action.type == constants.OPEN_WIDGET_STAT_POPUP) {
    return state.merge({ isOpen: true, informer: action.informer });
  }
  if (action.type == CLOSE_POPUP) {
    return defaultWidgetStatPopupState;
  }
  if (action.type == constants.ON_LOAD_WIDGET_STAT_SUCCESS) {
    const summary = new WidgetStatItem(action.stat.summary);
    const daily = new Immutable.Seq(action.stat.stat).map(
      stat => new WidgetStatItem(stat)
    );
    return state.merge({ daily, summary });
  }
  return state;
}

const defaultWidgetFormState = new Immutable.Map({
  isOpen: false,
  isCustom: false,
  informer: new Informer(),
  errors: {}
});

function widgetForm(state = defaultWidgetFormState, action) {
  if (action.type == constants.OPEN_WIDGET_FORM) {
    return state.set("isOpen", true);
  }
  if (action.type == constants.OPEN_WIDGET_EDIT_FORM) {
    const informer = state
      .get("informer")
      .merge({ id: action.id, name: action.name });
    return state.merge({ informer, isOpen: true });
  }
  if (action.type == constants.SET_WIDGET_FORM_FIELD) {
    let informer = state.get("informer").merge(action.payload);

    const keys = Object.keys(action.payload);
    const onlyName = keys.length == 1 && keys[0] == "name";

    const data = {};

    if (!onlyName) {
      const isCustom =
        action.payload.tpl != undefined || action.payload.css != undefined;

      data.isCustom = isCustom;

      if (!isCustom) {
        const generator = new TemplateGenerator(informer);
        const tplData = {
          css: generator.getCssTempl(),
          tpl: generator.getInformerTempl()
        };
        informer = informer.merge(tplData);
      }
    }

    data.informer = informer;

    return state.merge(data);
  }
  if (action.type == constants.TOGGLE_CATEGORY) {
    const informer = state.get("informer");
    let categories;

    if (action.checked) {
      categories = informer.categories.push(action.id);
    } else {
      const index = informer.categories.findIndex(id => id == action.id);
      categories = informer.categories.remove(index);
    }

    return state.set("informer", informer.set("categories", categories));
  }
  if (
    action.type == CLOSE_POPUP ||
    action.type == constants.ON_SAVE_WIDGET_FORM_SUCCESS
  ) {
    return defaultWidgetFormState;
  }
  if (action.type == constants.ON_SAVE_WIDGET_FORM_FAILD) {
    return state.set("errors", action.errors);
  }
  if (action.type == constants.CONFIRM_REPLACE) {
    let informer = state.get("informer");
    const generator = new TemplateGenerator(informer);

    informer = informer.merge({
      css: generator.getCssTempl(),
      tpl: generator.getInformerTempl()
    });
    const isCustom = false;

    return state.merge({ informer, isCustom });
  }
  if (action.type == constants.ON_LOAD_WIDGET_SUCCESS) {
    const categories = new Immutable.List(action.widget.categories);
    const informer = new Informer(action.widget).set("categories", categories);

    const generator = new TemplateGenerator(informer);

    const genCss = generator.getCssTempl();
    const genTpl = generator.getInformerTempl();

    const isCustom =
      genCss.trim() != informer.css.trim() ||
      genTpl.trim() != informer.tpl.trim();

    return state.merge({ informer, isCustom });
  }
  return state;
}

function teaserInfList(state = new Immutable.List(), action) {
  if (action.type == constants.ON_LOAD_TEASER_INF_SUCCESS) {
    return new Immutable.Seq(action.teaserInfList).map(
      teaser => new TeaserInf(teaser)
    );
  }
  return state;
}

function widgetListSort(state = { key: "stat.shows", order: "desc" }, action) {
  if (action.type == constants.SET_WIDGET_LIST_SORT) {
    return {
      key: action.key,
      order: action.order
    };
  }
  return state;
}

function widgetStatSort(state = { key: "date", order: "desc" }, action) {
  if (action.type == constants.SET_WIDGET_STAT_SORT) {
    return {
      key: action.key,
      order: action.order
    };
  }
  return state;
}

export default combineReducers({
  dateRange: dateRange(constants.SET_WIDGET_LIST_DATE_RANGE),
  widgetList,
  widgetPopup,
  widgetStatPopup,
  widgetForm,
  teaserInfList,
  widgetCopyPopup,
  widgetListSort,
  widgetStatSort,
  updateDate: updateDate(UPDATE_CONSTANTS)
});
